<template>
    <div>
        <v-layout justify-end column v-show="$store.state.showAdminHome">
            <v-flex xs12>
                <v-layout justify-end>
                    <v-btn type="button" round color="#FF7BA3" class="whiteText" v-on:click="toHome">
                        <v-icon>exit_to_app</v-icon>
                    </v-btn>
                </v-layout>
            </v-flex>
        </v-layout>
        <v-container fluid grid-list-xl class="containerCards" v-show="$store.state.showAdminHome">
            <v-layout justify-center>
                <v-flex xs10>
                    <v-card color="#FCE15C" class="elevation-12 cardHome" v-on:click="toCRUD">
                        <v-card-title class="textCardHome">
                            <br>
                            <br>
                            <br>
                            <b>Formulari</b>
                        </v-card-title>
                    </v-card>
                </v-flex>
            </v-layout>
            <v-layout justify-center>
                <v-flex xs10>
                    <v-card color="#2dde98" class="elevation-12 cardHome" v-on:click="toVarGame">
                        <v-card-title class="textCardHome">
                            <br>
                            <br>
                            <br>
                            <b>Variables</b>
                        </v-card-title>
                    </v-card>
                </v-flex>
            </v-layout>
            <v-layout justify-center>
                <v-flex xs10>
                    <v-card color="#B78DE4" class="elevation-12 cardHome">
                        <v-card-title class="textCardHome">
                            <br>
                            <br>
                            <br>
                            <a class="linkClass" :href="linkEstadistiques" target="_blank">
                                <b>Estadístiques</b>
                            </a>
                        </v-card-title>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
        <VarGame></VarGame>
        <Crud></Crud>
    </div>
</template>

<script>


    import Crud from '../components/QuestionsCRUD'
    import VarGame from '../components/VarGame'

    import {db} from '../firebaseConfig'

    let varGame = db.ref('varGame');

    export default {
        name: "AdminHome",
        components: {
            VarGame,
            Crud
        },
        data() {
            return {
                linkEstadistiques: null
            }
        },
        created() {

        },
        methods: {
            toHome() {
                this.$store.commit('showHomeTrue');
                this.$store.commit('showAdminHomeFalse');

            },
            toCRUD() {
                this.$store.commit('showCrudTrue');
                this.$store.commit('showAdminHomeFalse');

            },
            toVarGame() {

                varGame.child('linkEstadistiques').on('value', snap => this.linkEstadistiques = snap.val());

                this.$store.commit('showVarGameTrue');
                this.$store.commit('showAdminHomeFalse');

            }
        }
    }
</script>

<style scoped>

    .whiteText{
        color:white;
    }

    .linkClass {
        color: white;
        font-size: 15px;
        margin-right: 10px;
        z-index: 2;
        text-decoration: none;
    }

    .containerCards {
        margin-top: 15%;

    }

    .textCardHome {
        color: white;
        justify-content: center;
    }

    .cardHome {
        border-radius: 10px;
        height: 90px;
    }


</style>
